export default __webpack_public_path__ + "static/media/MI_Logo.6d421dc5.svg";